import React, { useState } from 'react';
import { ReserveWizzard } from '../ReserveWizzard';

export function ReserveButton()
{
    let [showWindow, setShowWindow] = useState(false);

    function openWindow()
    {
        setShowWindow(true);
    }

    function closeWindow()
    {
        setShowWindow(false);
    }

    return <div>
        <button onClick={openWindow} className='rezerwuj-button'>Rezerwuj</button>
        { showWindow && <ReserveWindow onClose={closeWindow} /> }
    </div>
}

export function ReserveWindow({ onClose }: { onClose: () => void})
{
    return  <div className="modal">
                <div className="modal-content">
                    <button className="close" onClick={onClose}>&times;</button>
                    <ReserveWizzard />
                </div>
            </div>
}